enum EIndividualKey {
  INDIVIDUAL = 'individual',
  SELF_EMPLOYED = 'selfEmployed',
  INDIVIDUAL_ENTREPRENEUR = 'individualEntrepreneur',
}

export default EIndividualKey;
